import { useCallback, useEffect } from 'react';
import {
  Flex,
  IconChevronRight,
  RemoteImage,
  Typography,
} from '@banhala/ui-kit';
import { useNavigator } from 'shared/src/utils';
import { useLogClickCommunityBanner } from '../hooks/useLogClickCommunityBanner';
import { useLogDisplayCommunityBanner } from '../hooks/useLogDisplayCommunityBanner';
import { useVoteBannerCount } from '../hooks/useVoteBannerCount';

interface CommunityBannerProps {
  goodsSno: number;
  imageUrl: string;
}

export const CommunityBanner = ({
  goodsSno,
  imageUrl,
}: CommunityBannerProps) => {
  const voteCount = useVoteBannerCount();
  const { navigator } = useNavigator();
  const logClickBanner = useLogClickCommunityBanner();
  const logDisplayBanner = useLogDisplayCommunityBanner();

  useEffect(() => {
    if (voteCount == null) return;
    logDisplayBanner(goodsSno);
  }, [goodsSno, logDisplayBanner, voteCount]);

  const handlePress = useCallback(() => {
    logClickBanner(goodsSno);
    navigator.moveToWebview('/community/talk/write?from=zzim');
  }, [logClickBanner, goodsSno, navigator]);

  if (voteCount == null) return null;

  return (
    <Flex.Row
      alignItems={'center'}
      gap={8}
      margin={{ horizontal: 16, bottom: 16 }}
      padding={{ horizontal: 12, vertical: 12 }}
      backgroundColor={'bg_secondary'}
      borderRadius={8}
      onPress={handlePress}
    >
      <Flex width={40} height={40} borderRadius={4} overflow={'hidden'}>
        <RemoteImage uri={imageUrl} width={40} height={40} doAnimate={false} />
      </Flex>
      <Flex flex={1} gap={2}>
        <Typography type={'subtitle2'} color={'content_primary'}>
          {'살까말까 고민되면, 투표를 올려보세요'}
        </Typography>
        <Typography type={'body4'} color={'content_secondary'}>
          {`진행 중인 투표 ${voteCount}개`}
        </Typography>
      </Flex>
      <IconChevronRight size={16} color={'content_tertiary'} />
    </Flex.Row>
  );
};
